import { addDatapointConfig } from 'owa-analytics-actions';
import { action } from 'satcheljs';
import type {
    QuickComposeEntrySourceType,
    FullComposeEntrySourceType,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

/**
 * Action invoked when interacts with 'New Event' button
 *
 * @param entrySource indicates how the form was entered
 * @param anchor anchor for quick compose form
 */
export const launchNewEvent = action(
    'launchNewEvent',
    (
        entrySource: QuickComposeEntrySourceType & FullComposeEntrySourceType,
        anchor: HTMLDivElement | string
    ) =>
        addDatapointConfig(
            {
                name: 'launchNewEvent',
                customData: {
                    owa_1: entrySource,
                },
            },
            {
                entrySource,
                anchor,
            }
        )
);
